import {
  SupplierCatalogConfig,
  currency,
  emptyColumn,
  fieldRowsToFields,
  text,
  WithRowId,
} from '../SupplierCatalog/supplierCatalogTypes'
import { INGRAM_MICRO_FIELD_ROWS, IngramMicroSftpItem } from './ingramMicroTypes'
import { ingramMicroItemToLineItem } from './ingramMicroLineItemMapping'

export const ingramMicroCatalogConfig: SupplierCatalogConfig<WithRowId<IngramMicroSftpItem>> = {
  supplier: 'Ingram Micro',
  endpoint: '/ingrammicro/catalog',
  rowKey: row => row.rowId,
  partNumber: row => text(row.ingramSKU),
  columns: [
    {
      label: 'Manufacturer',
      className: 'supplier-catalog-col-manufacturer',
      render: row => text(row.manufacturerName),
    },
    { label: 'Mfr Part #', className: 'supplier-catalog-col-mfr-part', render: row => text(row.mfgPN) },
    {
      label: 'Description',
      className: 'supplier-catalog-col-description',
      render: row => text([row.description1, row.description2].filter(Boolean).join(' ')),
    },
    { label: 'IMPRES Price', className: 'supplier-catalog-col-impres-price', align: 'right', render: emptyColumn },
    { label: 'MSRP', className: 'supplier-catalog-col-msrp', align: 'right', render: row => currency(row.listPrice) },
    {
      label: 'Product Category',
      className: 'supplier-catalog-col-product-category',
      render: row => text(row.cpuCode),
    },
    { label: 'Country of Origin', className: 'supplier-catalog-col-country', render: emptyColumn },
    { label: 'TAA', className: 'supplier-catalog-col-taa', render: emptyColumn },
  ],
  drawerFields: fieldRowsToFields(INGRAM_MICRO_FIELD_ROWS),
  toLineItem: (lineNumber, row) => ingramMicroItemToLineItem(lineNumber, row.mfgPN, row),
}
